import React from 'react';
import { motion } from 'framer-motion';
import { Users, PackageOpen, SplitSquareHorizontal, AlertOctagon } from 'lucide-react';
const strategies = [{
  icon: Users,
  title: 'UGC Auténtico',
  desc: 'Contenido generado por creadores que se siente nativo y genera confianza instantánea.',
  color: 'group-hover:text-[#00E5FF]'
}, {
  icon: PackageOpen,
  title: 'Experiencia Unboxing',
  desc: 'Revelación de producto diseñada para retener la atención en los primeros 3 segundos.',
  color: 'group-hover:text-[#95BF47]'
}, {
  icon: SplitSquareHorizontal,
  title: 'Comparativa en Pantalla Dividida',
  desc: 'Nosotros vs Ellos. Demostración visual clara de superioridad del producto.',
  color: 'group-hover:text-[#FFD700]'
}, {
  icon: AlertOctagon,
  title: 'Enfoque en Puntos de Dolor',
  desc: 'Agitación del problema y presentación de tu producto como la única solución lógica.',
  color: 'group-hover:text-red-400'
}];
export function Strategy() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#050505]" data-id="element-92">
      <div className="max-w-7xl mx-auto" data-id="element-93">
        <div className="mb-16 md:flex md:items-end md:justify-between" data-id="element-94">
          <div data-id="element-95">
            <h2 className="text-4xl font-bold mb-4" data-id="element-96">Estrategias Creativas</h2>
            <p className="text-gray-400 text-lg" data-id="element-97">
              Formatos probados que dominan el feed.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-98">
          {strategies.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="group p-8 rounded-2xl bg-[#111] border border-white/5 hover:border-white/20 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,255,255,0.05)] cursor-default" data-id="element-99">
              <item.icon className={`w-10 h-10 text-gray-500 mb-6 transition-colors duration-300 ${item.color}`} data-id="element-100" />
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-101">
                {item.title}
              </h3>
              <p className="text-gray-400" data-id="element-102">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}